export default __webpack_public_path__ + "static/media/modal-close.5c977dd8.svg";